import React, {useEffect} from 'react'
import ReactDOM from 'react-dom/client'

import TermlifeQuoter from './TermlifeQuoter'
import MortgageProtectionQuoter from './MortgageProtectionQuoter'
import BurialInsuranceQuoter from './BurialInsuranceQuoter'
import InsuranceMenu from './InsuranceMenu'

const AppWrapper = ({app}) => {

    const menu = [];

    const stateNames = [
        {
            label: 'Select your state',
            value: '',
        },
        {
            label: 'Alabama',
            value: 'AL',
        },
        {
            label: 'Alaska',
            value: 'AK',
        },
        {
            label: 'Arizona',
            value: 'AZ',
        },
        {
            label: 'Arkansas',
            value: 'AR',
        },
        {
            label: 'California',
            value: 'CA',
        },
        {
            label: 'Colorado',
            value: 'CO',
        },
        {
            label: 'Connecticut',
            value: 'CT',
        },
        {
            label: 'Delaware',
            value: 'DE',
        },
        {
            label: 'District Of Columbia',
            value: 'DC',
        },
        {
            label: 'Florida',
            value: 'FL',
        },
        {
            label: 'Georgia',
            value: 'GA',
        },
        {
            label: 'Hawaii',
            value: 'HI',
        },
        {
            label: 'Idaho',
            value: 'ID',
        },
        {
            label: 'Illinois',
            value: 'IL',
        },
        {
            label: 'Indiana',
            value: 'IN',
        },
        {
            label: 'Iowa',
            value: 'IA',
        },
        {
            label: 'Kansas',
            value: 'KS',
        },
        {
            label: 'Kentucky',
            value: 'KY',
        },
        {
            label: 'Louisiana',
            value: 'LA',
        },
        {
            label: 'Maine',
            value: 'ME',
        },
        {
            label: 'Maryland',
            value: 'MD',
        },
        {
            label: 'Massachusetts',
            value: 'MA',
        },
        {
            label: 'Michigan',
            value: 'MI',
        },
        {
            label: 'Minnesota',
            value: 'MN',
        },
        {
            label: 'Mississippi',
            value: 'MS',
        },
        {
            label: 'Missouri',
            value: 'MO',
        },
        {
            label: 'Montana',
            value: 'MT',
        },
        {
            label: 'Nebraska',
            value: 'NE',
        },
        {
            label: 'Nevada',
            value: 'NV',
        },
        {
            label: 'New Hampshire',
            value: 'NH',
        },
        {
            label: 'New Jersey',
            value: 'NJ',
        },
        {
            label: 'New Mexico',
            value: 'NM',
        },
        {
            label: 'New York',
            value: 'NY',
        },
        {
            label: 'North Carolina',
            value: 'NC',
        },
        {
            label: 'North Dakota',
            value: 'ND',
        },
        {
            label: 'Ohio',
            value: 'OH',
        },
        {
            label: 'Oklahoma',
            value: 'OK',
        },
        {
            label: 'Oregon',
            value: 'OR',
        },
        {
            label: 'Pennsylvania',
            value: 'PA',
        },
        {
            label: 'Rhode Island',
            value: 'RI',
        },
        {
            label: 'South Carolina',
            value: 'SC',
        },
        {
            label: 'South Dakota',
            value: 'SD',
        },
        {
            label: 'Tennessee',
            value: 'TN',
        },
        {
            label: 'Texas',
            value: 'TX',
        },
        {
            label: 'Utah',
            value: 'UT',
        },
        {
            label: 'Vermont',
            value: 'VT',
        },
        {
            label: 'Virginia',
            value: 'VA',
        },
        {
            label: 'Washington',
            value: 'WA',
        },
        {
            label: 'West Virginia',
            value: 'WV',
        },
        {
            label: 'Wisconsin',
            value: 'WI',
        },
        {
            label: 'Wyoming',
            value: 'WY',
        },
    ]

    const tobaccoOptions = [
        {
            label: 'Select tobacco use',
            value: '',
        },
        {
            label: 'None',
            value: 'None',
        },
        {
            label: 'Cigarettes',
            value: 'Cigarettes',
        },
        {
            label: 'Cigarettes + Other Nicotine Products',
            value: 'Cigarettes + Other Nicotine Products',
        },
        {
            label: 'Occasional pipe/cigar use only',
            value: 'Occasional pipe/cigar use only',
        },
        {
            label: 'Other Nicotine Products',
            value: 'Other Nicotine Products',
        },
    ]

    const insuranceOptions = JSON.parse(app.options)
    debugger

    if (parseInt(insuranceOptions.termlife) === 1) {
        menu.push({
            title: 'Term life',
            link: `/index.php?option=${app.componentName}&view=termlife`,
            active: app.ins === 'termlife',
        })
    }

    if (parseInt(insuranceOptions.burial) === 1) {
        menu.push({
            title: 'Burial Insurance',
            link: `/index.php?option=${app.componentName}&view=burial`,
            active: app.ins === 'burial',
        })
    }

    if (parseInt(insuranceOptions.mortgage) === 1) {
        menu.push({
            title: 'Mortgage Protection',
            link: `/index.php?option=${app.componentName}&view=mortgage`,
            active: app.ins === 'mortgage',
        })
    }

    return (

        <div className='quoter quote-results card front-end-edit my-4 mx-4 dz:tw-w-11/12'>
            <div className='quote-edit front-end-edit my-4 mx-4'>
                <div className='container'>
                    <InsuranceMenu menu={menu} />

                    <TermlifeQuoter
                        active={app.ins === 'termlife'}
                        stateNames={stateNames}
                        tobaccoOptions={tobaccoOptions}
                        token={app.token}
                        componentName={app.componentName}
                        task={app.task}
                        version={app.version}
                    />

                    <MortgageProtectionQuoter
                        active={app.ins === 'mortgage'}
                        stateNames={stateNames}
                        tobaccoOptions={tobaccoOptions}
                        token={app.token}
                        componentName={app.componentName}
                        task={app.task}
                        version={app.version}
                    />

                    <BurialInsuranceQuoter
                        active={app.ins === 'burial'}
                        stateNames={stateNames}
                        tobaccoOptions={tobaccoOptions}
                        token={app.token}
                        componentName={app.componentName}
                        task={app.task}
                        version={app.version}
                    />
                </div>
            </div>
        </div>
    )
}

export default AppWrapper
